export const ZOOM_MIN = 0.05
export const ZOOM_MAX = 10
